import toolsClient from "@/api/toolsClient"
import { toUrlParams } from "@/api/apiUtils"

const MULTIPART_HEADERS = { headers: { "Content-Type": "multipart/form-data" } }

const buildPodcastFormData = (podcastData) => {
  const data = new FormData()
  data.append("podcast", JSON.stringify(podcastData))
  if (podcastData.logoFile) {
    data.append("logo", podcastData.logoFile)
  }
  return data
}

export const getPodcasts = async (accountKey) => {
  const response = await toolsClient.get(`/podcasts/?accountKey=${accountKey}`)

  return response.data
}

export const getPodcast = async (podcastKey) => {
  const response = await toolsClient.get(`/podcasts/${podcastKey}`)

  return response.data
}

export const storePodcast = async (accountKey, podcastData) => {
  const response = await toolsClient.post(`/podcasts/?accountKey=${accountKey}`, buildPodcastFormData(podcastData), MULTIPART_HEADERS)

  return response.data
}

export const updatePodcast = async (podcastData) => {
  const response = await toolsClient.put(`/podcasts/${podcastData.key}`, buildPodcastFormData(podcastData), MULTIPART_HEADERS)

  return response.data
}

export const deletePodcast = async (podcastKey) => {
  await toolsClient.delete(`/podcasts/${podcastKey}`)
}

export const syncPodcast = async (accountKey, podcastKey) => {
  const response = await toolsClient.post(`/podcasts/${accountKey}/${podcastKey}/sync`)

  return response.data
}

export const checkPodcastSyncAvailability = async (accountKey, podcastKey) => {
  const response = await toolsClient.get(`/podcasts/${accountKey}/${podcastKey}/sync`)
  return response.data
}

export const getTaskSyncStatus = async (accountKey, taskId) => {
  const response = await toolsClient.get(`/podcasts/sync/task/${taskId}`)
  return response.data
}

export const importPodcast = async (accountKey, feedURL, stationKey) => {
  const response = await toolsClient.post(`/podcasts/${accountKey}/import?accountKey=${accountKey}`, {
    feed_url: feedURL,
    station_key: stationKey,
  })

  return response.data
}

export const getTaskStatus = async (taskId) => {
  const response = await toolsClient.get(`/podcasts/import/task/${taskId}`)

  return response.data
}

export const podcastPortalSearch = async ({ query = "", limit = 10, offset = 0 }) => {
  const response = await toolsClient.get(`/portal/search/podcasts?${toUrlParams({ limit, offset, search: query })}`)

  return response.data
}

export const getDistributionPlatforms = async (podcastKey) => {
  const response = await toolsClient.get(`/podcasts/${podcastKey}/distributionPlatforms`)

  return response.data
}

export const updateDistributionPlatforms = async (podcastKey, data) => {
  const response = await toolsClient.put(`/podcasts/${podcastKey}/distributionPlatforms`, data)

  return response.data
}
